import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useMasterAuth } from "@/contexts/MasterAuthContext";
import { Crown, Lock, Mail } from "lucide-react";

export default function MasterLogin() {
    const { login } = useMasterAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");
        try {
            await login(email, password);
            navigate("/master/dashboard");
        } catch (err) {
            setError(err?.response?.data?.detail || "Giriş başarısız");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div data-testid="master-login-page" className="min-h-screen bg-[#0a0a0a] text-white flex items-center justify-center px-4" style={{ fontFamily: "'Manrope', sans-serif" }}>
            <div className="w-full max-w-md">
                <div className="text-center mb-10">
                    <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-yellow-500/10 border border-yellow-500/30 rounded-full text-yellow-400 text-xs font-bold tracking-widest mb-6">
                        <Crown size={14} /> MASTER PANEL
                    </div>
                    <h1 className="text-4xl font-extrabold tracking-tight">DR AI FUTBOL</h1>
                    <p className="text-neutral-400 mt-2 text-sm">Multi-Tenant SaaS Yönetimi</p>
                </div>
                <form onSubmit={handleSubmit} className="bg-[#121212] border border-[#2a2a2a] rounded-2xl p-8 space-y-5">
                    <div>
                        <label className="block text-xs font-bold uppercase tracking-widest text-neutral-400 mb-2">E-posta</label>
                        <div className="relative">
                            <Mail size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-neutral-500" />
                            <input data-testid="master-login-email" required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full bg-[#0a0a0a] border border-[#2a2a2a] focus:border-yellow-500 rounded-lg pl-10 pr-4 py-3 outline-none transition-colors" placeholder="aliozer@draifutbol.com" />
                        </div>
                    </div>
                    <div>
                        <label className="block text-xs font-bold uppercase tracking-widest text-neutral-400 mb-2">Şifre</label>
                        <div className="relative">
                            <Lock size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-neutral-500" />
                            <input data-testid="master-login-password" required type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full bg-[#0a0a0a] border border-[#2a2a2a] focus:border-yellow-500 rounded-lg pl-10 pr-4 py-3 outline-none transition-colors" placeholder="••••••••" />
                        </div>
                    </div>
                    {error && <div data-testid="master-login-error" className="text-red-400 text-sm bg-red-500/10 border border-red-500/30 rounded-lg px-3 py-2">{error}</div>}
                    <button data-testid="master-login-submit" type="submit" disabled={loading} className="w-full bg-yellow-500 hover:bg-yellow-400 text-black font-bold uppercase tracking-widest py-3 rounded-lg transition-all disabled:opacity-50">
                        {loading ? "Giriş yapılıyor..." : "Master Olarak Giriş Yap"}
                    </button>
                </form>
                <div className="text-center mt-8 text-xs text-neutral-500">
                    <Link to="/" className="hover:text-yellow-400">← Ana siteye dön</Link>
                </div>
            </div>
        </div>
    );
}
